import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import components
import HomePage from "./Components/HomePage/HomePage";
import AdminLogin from "./Components/Admin/Auth/Auth";
import AdminDashboard from "./Components/Admin/AdminDashboard/AdminDashboard";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactUs from "./Components/ContactUs/ContactUs";
import Signup from "./Components/Customer/Signup";
import Login from "./Components/Customer/Login";
import UserProfile from "./Components/Customer/UserProfile";
import Products from "./Components/Products/Products";
import ProductDetails from "./Components/Products/ProductDetails";
import Cart from "./Components/Products/Cart";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";


function App() {
  return (
    <Router>
      <Routes>
        {/* Define routes for different pages */}
        <Route path="/" element={<HomePage />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        {/* <Route path="/admin-dashboard" element={<AdminDashboard />} /> */}
                <Route path="/admin-dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
        <Route path="/our-story" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path='/products' element={<Products/>}/>
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/cart" element={<Cart />} /> {/* Your cart page route */}
      </Routes>
    </Router>
  );
}

export default App;
